import { render, staticRenderFns } from "./totalShipment.vue?vue&type=template&id=daccfbfa&scoped=true"
import script from "./totalShipment.vue?vue&type=script&lang=js"
export * from "./totalShipment.vue?vue&type=script&lang=js"
import style0 from "./totalShipment.vue?vue&type=style&index=0&id=daccfbfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daccfbfa",
  null
  
)

export default component.exports